import { FormikContextType, FormikHelpers, FormikProvider } from "formik";
import { FC, useEffect, useMemo, useState } from "react";
import { debounce } from 'lodash'

export interface OdFormProps  {
  formikCtrl: FormikContextType<any>;
}

const OdForm: FC<OdFormProps> = ({ children, formikCtrl, ...props }) => {
  const { handleSubmit, errors, touched } = formikCtrl
  const [srAlert, setSrAlert] = useState('')
  const promptSR = useMemo(() => {
    return debounce((errorsBag:Record<string, string>, touchedBag:Record<string, boolean> ) => {
      setSrAlert(
        Object.keys(errorsBag).flatMap(k => touchedBag[k] && errorsBag[k] ? [errorsBag[k]] : []).join(' ')
      )
    }, 500)
  }, [])
  useEffect(() => {
    promptSR(errors as any, touched as any)
  }, [JSON.stringify(Object.values(errors)), JSON.stringify(touched)])

  return (
    <FormikProvider value={formikCtrl}>
      <form onSubmit={handleSubmit} {...props}>
        {children}
      </form>
      <div className="sr-only" role="alert" aria-live="polite">
        {srAlert}
      </div>
    </FormikProvider>
  )
}

export default OdForm;

export interface OnSubmit<Values> {
  (values: Values, formikHelpers: FormikHelpers<Values>): void | Promise<any>;
} 
